module.exports = __webpack_public_path__ + "img/logo.2899dcc1.webp";